import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-[#EA8649]'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <button
          onClick={() => handleNavigation('/')}
          className="flex items-center gap-3 hover:opacity-70 transition-opacity"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/b7dszbta_P-Picsart-BackgroundRemover%20%282%29.png"
            alt="RP Logo"
            className="h-10 w-auto"
          />
          <span className={`text-xl font-bold tracking-tight ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Ruchi Patel
          </span>
        </button>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => handleNavigation('/work')}
            className={`text-sm font-medium transition-colors ${
              isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'
            } ${location.pathname === '/work' ? 'font-bold' : ''}`}
          >
            Work
          </button>
          <button
            onClick={() => handleNavigation('/art')}
            className={`text-sm font-medium transition-colors ${
              isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'
            } ${location.pathname === '/art' ? 'font-bold' : ''}`}
          >
            Art
          </button>
          <button
            onClick={() => handleNavigation('/about')}
            className={`text-sm font-medium transition-colors ${
              isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'
            } ${location.pathname === '/about' ? 'font-bold' : ''}`}
          >
            About
          </button>
          <Button
            onClick={() => handleNavigation('/contact')}
            size="sm"
            className="bg-[#EA8649] hover:bg-[#d97640] text-white transition-colors"
          >
            Contact
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden p-2 ${isScrolled ? 'text-gray-900' : 'text-white'}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-4">
            <button
              onClick={() => handleNavigation('/work')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
            >
              Work
            </button>
            <button
              onClick={() => handleNavigation('/art')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
            >
              Art
            </button>
            <button
              onClick={() => handleNavigation('/about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
            >
              About
            </button>
            <Button
              onClick={() => handleNavigation('/contact')}
              size="sm"
              className="w-full bg-[#EA8649] hover:bg-[#d97640] text-white transition-colors"
            >
              Contact
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
